import React, { useEffect, useRef } from 'react';

function AdBanner({ 
  slot, 
  format = 'auto', 
  responsive = true,
  style = {},
  className = ''
}) {
  const adRef = useRef(null);

  useEffect(() => {
    const loadAd = () => {
      try {
        // Push ad to AdSense queue
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      } catch (error) {
        console.error('AdSense error:', error);
      }

      // Check if ad loaded after a delay
      setTimeout(() => {
        if (adRef.current) {
          const insElement = adRef.current.querySelector('ins');
          if (insElement && insElement.getAttribute('data-ad-status') !== 'filled') {
            // Ad didn't load, hide container
            adRef.current.style.display = 'none';
          }
        }
      }, 1000);
    };

    loadAd();
  }, []);

  return (
    <div ref={adRef} className={`ad-container ${className}`} style={{ textAlign: 'center', ...style }}>
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-8537103009270516"
        data-ad-slot={slot}
        data-ad-format={format}
        data-full-width-responsive={responsive.toString()}
      />
    </div>
  );
}

export default AdBanner;
